import { createContext, FC, useContext } from "react";

/**
 * Signals that the subtree renders inside the workspace **pages** runtime.
 *
 * Shared chrome components (e.g. `Section`) read this to switch to their
 * pages-specific presentation — flat background, full-width content — while
 * every other surface of the app (dashboard, story player, standalone article
 * routes) sees the default `false` and renders unchanged.
 */
const PagesUiContext = createContext(false);

export const usePagesUi = () => useContext(PagesUiContext);

export const PagesUiProvider: FC = ({ children }) => (
  <PagesUiContext.Provider value={true}>{children}</PagesUiContext.Provider>
);
